import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import { isLoggedInSelector } from 'store/modules/user/selectors'

import LoggedIn from '../LoggedIn'
import LoggedOut from '../LoggedOut'

export default function Info(props: { collapseCurrency?: boolean }) {
  const isAppInitialized = useAppSelector(isAppInitializedSelector)
  const isLoggedIn = useAppSelector(isLoggedInSelector)

  if (!isAppInitialized) {
    return null
  }

  return isLoggedIn ? <LoggedIn collapseCurrency={props.collapseCurrency} /> : <LoggedOut />
}
